import css from "./primitives.module.css";

type Status = "published" | "draft";

/**
 * §11.1 screen 3: "status chip (PUBLISHED teal on rgba(74,155,155,.18) /
 * DRAFT periwinkle on --panel-2)".
 */
export function StatusChip({ status }: { status: Status }) {
  return (
    <span
      className={`${css.statusChip} ${
        status === "published" ? css.statusPublished : css.statusDraft
      }`}
    >
      {status === "published" ? "PUBLISHED" : "DRAFT"}
    </span>
  );
}
